
import { defineComponent } from "vue";
import VideoIndexTable from "@/components/entity/VideoPublicIndexTable.vue";
import { mdiReload, mdiPlus } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";

export default defineComponent({
  data() {
    return {
      dataReload: false,
      mdiReload,
      mdiPlus,
      isNewsLoading: false,
    };
  },
  emits: ["changeTitle"],
  methods: {
    triggerDataReload() {
      this.dataReload = !this.dataReload;
    },
  },
  mounted() {
    this.$emit("changeTitle", "Videos");
  },
  components: {
    VideoIndexTable,
    SvgIcon,
  },
});
